angular.module('cn')
.service('networkRelationsRepository', [
  'ENV',
  '$http',
  '$rootScope',
  '$q',
  function(
    ENV,
    $http,
    $rootScope,
    $q
  ) {

    var _addRelation = function(receiverAccount, senderAccount) {
      var request = {
        method: 'POST',
        url: `${ENV.EIAM_URL}/customeraccounts/relations`,
        data: {
          customer_account_relations: [
            {
              sender: senderAccount.id,
              receiver: receiverAccount.id
            }
          ]
        }
      };
      return $http(request)
      .then(function(res) {
        return {
          id: res.data.data[0].id,
          sender: {
            id: senderAccount.id,
            name: senderAccount.name,
            network: null
          },
          receiver: {
            id: receiverAccount.id,
            name: receiverAccount.name,
            network: null
          }
        };
      })
      .catch(function(err) {
        $rootScope.$emit('onBackendError', err.data.data.message);
        return $q.reject(err);
      });
    };

    this.addRetailer = function(senderAccount, receiverAccount) {
      return _addRelation(receiverAccount, senderAccount).then(function(relation) {
        return {
          id: relation.receiver.id,
          name: relation.receiver.name,
          relationId: relation.id
        };
      });
    };

    this.deleteRelation = function(relationId) {
      var request = {
        method: 'DELETE',
        url: `${ENV.EIAM_URL}/customeraccounts/relations/${relationId}`
      };
      return $http(request)
      .catch(function(err) {
        $rootScope.$emit('onBackendError', err.data.data.message);
        return $q.reject(err);
      });
    };

    // TO-DO this is intented to be called with the root account,
    // if eventually we have to call it for every network account it must be refactored
    // to prevent repeat the same backend request for every account
    this.getRelations = function(account) {
      return $http({
        method: 'GET',
        url: `${ENV.EIAM_URL}/customernetworks/${account.network.id}/relations`
      })
      .then(function(raw) {
        var relations = {};
        if (!raw.data.data.customer_account_relations) {
          return relations;
        }
        var data = Object.keys(raw.data.data.customer_account_relations).map(function(relationId) {
          var item = raw.data.data.customer_account_relations[relationId];
          return {
            id: relationId,
            sender: {
              id: item.sender.id,
              name: item.sender.name,
              networkId: item.sender.network
            },
            receiver: {
              id: item.receiver.id,
              name: item.receiver.name,
              networkId: item.receiver.network
            }
          };
        });

        // retailer means: all the relation in which the given network is the sender
        // and the NOT the reciver (if it's both, it's an internal relation)
        // for this version, it also filters the relations for the non root accounts
        relations.retailers = data.filter(function(relation) {
          return (
            relation.sender.networkId === account.network.id &&
            relation.receiver.networkId !== account.network.id &&
            relation.sender.id === account.id
          );
        }).map(function(relation) {
          return {
            id: relation.receiver.id,
            name: relation.receiver.name,
            relationId: relation.id
          };
        });

        // senders means: all the relation in which the given network is NOT the sender
        // and the the reciver (if it's both, it's an internal relation)
        var ids = [];
        relations.senders = data.filter(function(relation) {
          if (ids.indexOf(relation.id) > -1) {
            return;
          }
          ids.push(relation.id);
          return (
            relation.sender.networkId !== account.network.id &&
            relation.receiver.networkId === account.network.id
          );
        }).map(function(relation) {
          return {
            id: relation.sender.id,
            name: relation.sender.name
          };
        });

        return relations;
      }).catch(function(err) {
        $rootScope.$emit('onBackendError', 'Can not get network external relations');
        return $q.reject(err);
      });
    };

  }
]);



// WEBPACK FOOTER //
// ./src/cn/services/networkRelationsRepository.js